/** Little-endian unsigned reads that return null instead of reading past the end. */

export function readU16LE(bytes: Uint8Array, offset: number): number | null {
  const lo = bytes[offset];
  const hi = bytes[offset + 1];
  if (lo === undefined || hi === undefined) return null;
  return lo | (hi << 8);
}

export function readU32LE(bytes: Uint8Array, offset: number): number | null {
  const b0 = bytes[offset];
  const b1 = bytes[offset + 1];
  const b2 = bytes[offset + 2];
  const b3 = bytes[offset + 3];
  if (
    b0 === undefined ||
    b1 === undefined ||
    b2 === undefined ||
    b3 === undefined
  ) {
    return null;
  }
  return (b0 | (b1 << 8) | (b2 << 16) | (b3 << 24)) >>> 0;
}
